import { Navigate, useLocation } from "react-router-dom";
import { useApp } from "../context/AppContext";

/**
 * RoleGuard
 * ─────────
 * Wraps any route element and enforces:
 *   1. Must be logged in
 *   2. If mustChangePw → redirect to /change-password before anything else
 *   3. If allowedRoles provided → user's role must be in the list
 *
 * Usage:
 *   <Route path="/settings" element={<RoleGuard allowedRoles={["admin"]}><Settings /></RoleGuard>} />
 *   <Route path="/portal/*" element={<RoleGuard allowedRoles={["student","parent"]}><StudentLayout /></RoleGuard>} />
 */
export default function RoleGuard({ children, allowedRoles = [] }) {
    const { isLoggedIn, role, mustChangePw } = useApp();
    const location = useLocation();

    // Not logged in → back to login
    if (!isLoggedIn) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // Must change password → force redirect (exempt only /change-password itself)
    if (mustChangePw && location.pathname !== "/change-password") {
        return <Navigate to="/change-password" replace />;
    }

    // Role check
    if (allowedRoles.length > 0 && !allowedRoles.includes(role)) {
        return <Navigate to="/unauthorized" replace />;
    }

    return children;
}